import { render, staticRenderFns } from "./tagged_articles.vue?vue&type=template&id=7ae3bfe2&scoped=true"
import script from "./tagged_articles.vue?vue&type=script&lang=js"
export * from "./tagged_articles.vue?vue&type=script&lang=js"
import style0 from "./tagged_articles.vue?vue&type=style&index=0&id=7ae3bfe2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae3bfe2",
  null
  
)

export default component.exports